// Remito number entry: four digits of punto de venta, then eight of número.
// Digits typed past a full punto de venta (fast typing, or pasting "0001-00000045") belong to the
// número, so they are carried over instead of dropped.
const PUNTO_VENTA_LENGTH = 4;
const NUMERO_LENGTH = 8;

const digitsOf = (value) => String(value || '').replace(/\D/g, '');

export function applyPuntoVentaInput(value, currentNumero = '') {
  const digits = digitsOf(value);
  const overflow = digits.slice(PUNTO_VENTA_LENGTH, PUNTO_VENTA_LENGTH + NUMERO_LENGTH);
  return {
    punto_venta: digits.slice(0, PUNTO_VENTA_LENGTH),
    numero_remito: currentNumero || overflow,
    advance: digits.length >= PUNTO_VENTA_LENGTH,
  };
}

export function applyNumeroRemitoInput(value) {
  const numero = digitsOf(value).slice(0, NUMERO_LENGTH);
  return { numero_remito: numero, advance: numero.length === NUMERO_LENGTH };
}

// Road freight convention: one cubic metre is charged as 300 kg.
export const KG_POR_M3_AFORO = 300;

const toAmount = value => {
  const parsed = Number(String(value ?? '').replace(',', '.'));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

/** Volumetric weight of a remito: the larger of real kilos and m3 at KG_POR_M3_AFORO. */
export function autoKgAforado({ kg_reales, m3 }) {
  const aforo = Math.max(toAmount(kg_reales), toAmount(m3) * KG_POR_M3_AFORO);
  return aforo > 0 ? String(Math.round(aforo * 1000) / 1000) : '';
}

/**
 * Applies a remito field edit. While kg aforado is empty or still holds the computed value,
 * it follows kilos and m3; a value the operator typed is kept.
 */
export function withAutoKgAforado(draft, field, value) {
  const next = { ...draft, [field]: value };
  if (field !== 'kg_reales' && field !== 'm3') return next;
  const current = String(draft.kg_aforado ?? '');
  if (current === '' || current === autoKgAforado(draft)) next.kg_aforado = autoKgAforado(next);
  return next;
}
